import React, { useEffect, useState } from 'react';
import Stars from '../stars/Stars';
import styles from './styles.module.scss';

const REVIEWS = [
  {
    title: 'Finally Sleeping Again',
    text: 'Have really bad anxiety and this helps a lot :) thank you, haven’t slept like this in years.',
    signature: 'Maxpup94',
  },
  {
    title: 'Like a Cozy Fire',
    text: 'This app is the equivalent of sitting next to a warm fire during a cold winter night.',
    signature: 'lexirio',
  },
  {
    title: 'Pain-Free Relaxation',
    text: 'Excellent app, no pain, feel relaxed and really calm. Sleep is coming.',
    signature: '(Anonymous)',
  },
  {
    title: 'A Lifesaver for Anxiety',
    text: 'I discovered Loóna at a time in my life when I was extremely anxious and down. Loóna helped me at night to stop overthinking and immediately relax. I then came to look forward to laying in bed and listening to the stories that not only calmed me visually with the immersive escapes but ones that I could relate to and left me refreshed.',
    signature: 'gigi10894',
  },
  {
    title: 'Helps My Racing Mind',
    text: 'I struggle with anxiety, depression, & ADHD. My anxiety & hyperactivity get worse at night, & Loóna has helped me put my mind to rest.',
    signature: 'Meia Ojeda',
  },
];

export const ReviewCarousel = () => {
  const [currentReviewIndex, setCurrentReviewIndex] = useState(0);
  const [isInTransition, setIsInTransition] = useState(false);

  useEffect(() => {
    const startTime = Date.now();
    const reviewDelay = 4000;
    const transitionStart = 500;

    const timer = setInterval(() => {
      const elapsedTime = Date.now() - startTime;
      setCurrentReviewIndex(
        Math.floor((elapsedTime / reviewDelay) % REVIEWS.length),
      );
      if (elapsedTime % reviewDelay >= reviewDelay - transitionStart) {
        setIsInTransition(true);
      } else {
        setIsInTransition(false);
      }
    }, 100);
    return () => {
      clearInterval(timer);
    };
    // eslint-disable-next-line
  }, []);

  const review = REVIEWS[currentReviewIndex];
  return (
    <div
      className={`${styles.container} ${
        isInTransition ? styles.transitionOut : styles.transitionIn
      }`}
    >
      <Stars />
      <div className={styles.wrapper}>
        <div className={styles.title}>{review.title}</div>
        <div className={styles.signature}>{review.signature}</div>
      </div>
      <div className={styles.text}>{review.text}</div>
    </div>
  );
};
